// src/draft/datasources/reservesTeamsData.ts

import type { WebContext } from "~/src/Shared/Types";

const reservesTeamsIdKings = {
  espana: 79,
  americas: 81,
  italia: 157,
  brazil: 165,
};

const reservesTeamsIdQueens = {
  espana: 80,
  americas: 82,
};

export const getWebContextReserveTeamsData = (webContext: WebContext): { [key: string]: number } => {
  if (webContext === "queens") {
    return reservesTeamsIdQueens;
  } else {
    return reservesTeamsIdKings;
  }
};
